// extracted by mini-css-extract-plugin
export default {"root":"_1v7l_","item":"_3HVfZ"};